import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Article.css";
import NavComplete from "../Component/Navbar1";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Alert from "react-bootstrap/Alert";
import Footer from "../Component/footer";
import Card from "react-bootstrap/Card";
import LoadingImage from "../Component/Loadingimage";
import { useRef } from "react";
// {localStorage.getItem("bahasa") === "ing"?``:``}

const Article4 = () => {
  const handleCardClick = (link) => {
    window.location.href = `${link}`;
  };
  const section1 = useRef(null);
  const section2 = useRef(null);

  const scrollToPromo = (ref) => {
    const navbarHeight = 88; // Replace with the actual height of your navigation bar
    const rect = ref.current.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetOffset = rect.top + scrollTop - navbarHeight;

    window.scrollTo({
      top: targetOffset,
      behavior: "smooth",
    });
  };
  const togglescroll1 = () => {
    scrollToPromo(section1);
  };
  const togglescroll2 = () => {
    scrollToPromo(section2);
  };
  return (
    <article>
      <div id="containerss">
        <NavComplete />
        <Container
          className="info-page nunito"
          style={{
            color: "white",
            marginTop: "80px",
            marginBottom: "80px",
            maxWidth: "900px",
          }}
        >
          <Breadcrumb>
            <Breadcrumb.Item href="/Informasi">Blog</Breadcrumb.Item>
            <Breadcrumb.Item active>
              {localStorage.getItem("bahasa") === "ing"
                ? `5 Steps to Keep Your Car's Engine Clean and Durable!`
                : `5 Langkah Ini Akan Membuat Mesin Mobil Kamu Bersih dan Lebih Awet!`}
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <Col>
              <h1 className="roleway">
                {localStorage.getItem("bahasa") === "ing"
                  ? `5 Steps to Keep Your Car's Engine Clean and Durable!`
                  : `5 Langkah Ini Akan Membuat Mesin Mobil Kamu Bersih dan Lebih Awet!`}
              </h1>
              <div style={{ marginBottom: "15px", gap: "20px" }}>
                <i style={{ padding: "0px 2px" }} class="bi bi-person"></i>
                <a
                  style={{ padding: "0px 5px", marginRight: "10px" }}
                  target="blank_"
                  href="https://www.instagram.com/rezzaalviansyah/"
                >
                  Rezza
                </a>
                <i
                  style={{ padding: "0px 2px" }}
                  class="bi bi-calendar4-week"
                ></i>
                <span style={{ padding: "0px 5px" }}>22 November 2023</span>
              </div>
              <img
                src="https://i.ibb.co.com/Q89Ny03/mobil-we.webp"
                alt="stracehs-car"
                className="info-image"
              />
              <Alert
                variant="dark"
                style={{
                  background:
                    "linear-gradient(156deg, rgba(0,0,0,1) 41%, rgba(250,0,8,1) 120%)",
                  color: "white",
                  borderColor: "red",
                }}
                className="gotham"
              >
                <h3 className="gotham">
                  {localStorage.getItem("bahasa") === "ing"
                    ? "Article Content: "
                    : "Isi Artikel: "}
                  {localStorage.getItem("bahasa") === "ing"
                    ? `5 Steps to Keep Your Car's Engine Clean and Durable!`
                    : `5 Langkah Ini Akan Membuat Mesin Mobil Kamu Bersih dan Lebih Awet!`}
                </h3>
                <ul>
                  <li onClick={togglescroll1}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Steps to Clean Your Car's Engine`
                      : `Langkah-langkah Membersihkan Mesin Mobil`}
                  </li>
                  <li onClick={togglescroll2}>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Liquids Used to Clean the Car Engine`
                      : `Cairan Yang Digunakan Untuk Membersihkan Mesin Mobil`}
                  </li>
                </ul>
              </Alert>
              <div style={{ textAlign: "start" }}>
                <p>
                  {localStorage.getItem("bahasa") === "ing"
                    ? `Maintaining a car involves not only cleaning its exterior and interior but also its engine. While the engine might not need frequent cleaning, there should be a dedicated time within a certain period to clean the engine space to prevent damage.
The engine compartment in a car is susceptible to dust and dirt, and if ignored, it can damage the engine, leading to decreased performance. But don't worry, this article will help you maintain your car's engine to keep its performance stable.`
                    : `Merawat mobil bukan hanya dengan membersihkan bagian eksterior dan interior mobil, tetapi juga bagian mesinnya. Meski mungkin untuk bagian mesin itu nggak perlu sering-sering, tetapi perlu ada waktu khusus dalam kurun waktu tertentu untuk membersihkan bagian ruang mesin mobil agar tidak merusak mesin mobil.
Ruang mesin pada mobil itu rentan terpapar debu dan kotoran, bahkan bila diabaikan akan merusak mesin dan membuat performa mobil kamu menurun. Tapi kamu nggak perlu khawatir, artikel ini akan membantu kamu untuk merawat mesin mobil kamu agar performanya tetap stabil.`}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section1}>
                <b>
                  <h2 style={{ marginBottom: "20px" }} className="roleway">
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Steps to Clean Your Car's Engine`
                      : `Langkah-langkah Membersihkan Mesin Mobil`}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/zsPH7T1/detailing-machine.jpg"
                  alt="compoundning-car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `1. Prepare Tools and Materials Tools and materials are your weapons to eliminate stubborn stains on your car's engine. So, prepare the necessary tools and materials such as brushes, cloths, shampoo, a brush, and degreaser.`
                      : `1. Menyiapkan Alat dan Bahan Alat dan bahan merupakan senjata tempur kamu untuk membasmi noda-noda yang membandel pada mesin mobil kamu. Jadi kamu bisa mempersiapkan alat dan bahan-bahan yang diperlukan seperti; kuas, kain lap, shampoo, sikat, dan degreaser.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `2. Cool Down the Car Engine First The car engine is like our head – when stressed, it's easy to get agitated. Usually, in such situations, we tend to take actions that are harmful to ourselves and others. So, it needs to be cooled down for a while. Don't let emotions take over. Similarly, if the car engine is cleaned when it's still hot, it will be sensitive and could damage the engine. Therefore, before starting to clean the car engine, ensure that the engine is cool.`
                      : `2. Dinginkan Mesin Mobil Dulu Mesin mobil itu ibarat kepala kita, kalo lagi stress pasti mudah emosi dan biasanya dalam keadaan seperti itu, kita seringkali melakukan tindakan-tindakan yang merugikan dirinya bahkan merugikan orang lain. Jadi perlu didinginkan sejenak, jangan biarkan emosi menguasai diri kita. Demikian juga mesin mobil, kalo dibersihkan dalam keadaan masih panas pasti akan sensitif dan justru membuat mesin mobil jadi rusak. Jadi sebelum mulai membersihkan mesin mobil, pastikan mesin mobil kamu dalam keadaan dingin.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `3. Remove the Car Battery Before removing the car battery, you can clean the dust and dirt stuck on the engine surface. After that, disconnect the car battery, giving you more freedom to safely clean the bottom part. And most importantly, ensure that the car battery, along with its cables, bolts, and terminals, is stored in a dry place.`
                      : `3. Melepas Aki Mobil Sebelum melepas aki mobil, kamu bisa membersihkan dulu debu-debu dan kotoran yang menempel di permukaan mesin. Setelah itu, lepaskan aki mobil, dan kamu bisa lebih leluasa untuk membersihkan bagian bawah dengan aman. Dan yang terpenting, pastikan aki mobil beserta kabel, baut, dan perintilannya tersimpan dalam ruang yang kering ya.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `4. Clean the Bottom of the Car Hood Before starting to clean the car engine, make sure to clean the bottom of the engine hood first. The cleaning process is quite simple – use the prepared cleaning solution and then clean the dirt using a brush and cloth. Once the shampoo is evenly spread, rinse it with water slowly to avoid water splashes hitting areas where they shouldn't. After rinsing, dry it using a microfiber cloth.`
                      : `4. Bersihkan Bagian Bawah Kap Mobil Sebelum memulai membersihkan bagian mesin mobil, pastikan kalo kamu membersihkan bagian bawah kap mesin terlebih dulu. Nah, cara membersihkannya cukup mudah ko yaitu dengan manfaatkan cairan pembersih yang sudah kamu disiapkan, lalu tinggal dibersihkan deh kotoran yang menempel menggunakan sikat dan kuas. Setelah shampoonya sudah merata, tinggal kamu bilas dengan air secara perlahan, tujuannya agar cipratan air tidak mengenai bagian yang seharusnya tidak boleh kena air. Setelah dibilas, tinggal kamu keringkan menggunakan lap microfiber.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `5. Reinstall the Car Battery Once it's adequately dried, reinstall the previously removed car battery. After that, it's important to start the engine and listen to the sound of the car engine to check for any emerging issues. If the engine sound is normal, you can turn it off.`
                      : `5. Memasang Kembali Aki Mobil Nah kalo dirasa sudah cukup kering, tinggal kamu pasang kembali aki yang sebelumnya kamu lepas. Setelah itu, penting untu menyalakan mesin dan dengarkan suara mesin mobilnya, tujuannya untuk mencari tahu apakah ada masalah yang muncul atau tidak. Jika bunyi mesin sudah normal bisa dimatikan kembali.`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Row>
            <Col>
              <section ref={section2}>
                <b>
                  <h2 style={{ marginBottom: "20px" }} className="roleway">
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Liquids Used to Clean the Car Engine`
                      : `Cairan Yang Digunakan Untuk Membersihkan Mesin Mobil`}
                  </h2>
                </b>
                <img
                  src="https://i.ibb.co.com/swPR4n7/coating-image.webp"
                  alt="Coating-car"
                  className="info-image"
                />
                <div>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `1. If you clean the car engine only with water, the results won't be optimal. There's a liquid cleaner for car engines that you can use, namely, engine conditioner.
So, this engine conditioner is made from a solvent that, when sprayed, forms foam. The liquid is proven effective in cleaning deposits on the engine, fuel chamber, and throttle body.`
                      : `1. Kalo membersihkan mesin mobil cuma dengan bilasan air, pasti hasilnya nggak akan maksimal. Nah, ada salah satu cairan pembersih mesin mobil yang bisa kamu gunakan yaitu engine conditioner.
Jadi, engine conditioner ini terbuat dari bahan solvent yang ketika disemprotkan akan berbentuk busa atau foam. Cairan terbukti ampuh untuk membersihkan kerak-kerak yang ada pada bagian mesin, ruang bahan bakar, hingga throttle body.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `2. If the engine conditioner is for cleaning the inside of the engine, there's also a cleaner for the outside of the engine called engine degreaser. This engine degreaser is a solvent with a tougher texture, as it's used to bind and dissolve dirt on the engine. Specifically, this liquid is used to clean dirt on the outer surface of the engine.
Its usage is quite simple – you just need to spray this liquid in every corner of the engine space, then rinse it with water, and let it sit for a while. Also, use a cleaning cloth to remove the remaining liquid.`
                      : `2. Kalo cairan engine conditioner itu untuk membersikan bagian dalam mesin ya, nah ada juga ini cairan pembersih untuk bagian luar mesin yaitu engine degreaser. Jadi, engine degreaser ini berbahan solvent dengan tekstur lebih keras, karena berfungsi untuk mengikat dan melarutkan kotoran pada mesin. Tepatnya, cairan ini digunakan untuk membersihkan kotoran pada permukaan luar mesin.
Cara penggunaannya pun cukup mudah, kamu hanya perlu menyemprotkan cairan ini pada semua sudut ruang mesin, lalu tinggal diguyur deh dengan air, setelah itu biarkan beberapa saat. Bilas pula dengan kain pembersih untuk membersihkan sisa-sisa cairan.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `3. While cleaning the car engine, some parts are difficult to clean, such as the engine crankcase and oil channels. But don't worry, there's a special liquid you can use, namely, engine flush. So, this liquid can be used when you want to change the oil filter to prevent oil circulation from being obstructed by dirt. Its usage is also simple – you just need to pour the engine flush into the engine mixing with oil, then drain it until it's clean.
This special liquid can be poured into the engine through the oil hole. Then, you can start the engine for about 15 minutes, after which you can dispose of the liquid through the oil drain. The cleaning content of the engine flush can help clean sludge and carbon on the car's piston rings.`
                      : `3. Saat membersihkan bagian mesin mobil, ada bagian mesin yang memang susah untuk dibersihkan yaitu bagian karter mesin dan jalur oli. Tapi tenang, kamu nggak perlu khawatir karena ada cairan khusus yang bisa kamu gunakan, yaitu engine flush. Jadi, cairan ini bisa digunakan ketika ingin mengganti filter oli agar sirkulasi oli tidak terhambat akibat tumpukan kotoran. Cara penggunaannya juga mudah ko, kamu hanya perlu memasukan engine flush ke dalam ruang mesin bercampur oli, lalu dikuras hingga bersih.
Cairan khusus ini bisa dimasukkan ke dalam mesin melalui lubang oli. Lalu kamu bisa menyalakan mesin sekitar 15 menitan, setelah itu cairan tersebut kamu buang melalui pembuangan oli. Kandungan pembersih dari engine flush bisa membantu membersihkan sludge dan karbon di ring piston mobil.`}
                  </p>
                  <p>
                    {localStorage.getItem("bahasa") === "ing"
                      ? `Those are some tips you can follow to maintain your car's engine to ensure a comfortable driving experience. So, don't just focus on the interior and exterior aesthetics of the car; pay attention to the engine too!`
                      : `Nah itu dia beberapa tips yang bisa kamu lakukan untuk merawat mesin mobil kamu agar tetap nyaman saat dipakai untuk berkendara. Jadi, jangan cuma fokus pada bagian interior dan eksterior alias estetika mobil saja, bagian mesin juga perlu kamu perhatikan!`}
                  </p>
                </div>
              </section>
            </Col>
          </Row>
          <Card
            className="bg-dark "
            style={{
              position: "relative",
              overflow: "hidden",
              alignSelf: "center",
            }}
            onClick={() => handleCardClick("/layanan-harga")}
          >
            <LoadingImage
              src="https://i.ibb.co.com/zsPH7T1/detailing-machine.jpg"
              alt="Card image"
              className="card-overlay"
            />
            <Card.ImgOverlay
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "start",
                flexDirection: "column",
                color: "red",
              }}
            >
              <Card.Title>
                <b>Detailing</b>
              </Card.Title>
              <Card.Text
                style={{ backdropFilter: "blur(2px)" }}
                className="nunito"
              >
                {localStorage.getItem("bahasa") === "ing"
                  ? ` Solve your car problem at Wecarcare.`
                  : `Selesaikan masalah mobil mu di Wecarcare`}
              </Card.Text>
            </Card.ImgOverlay>
          </Card>
        </Container>
        <Footer />
      </div>
    </article>
  );
};

export default Article4;
